import { autoinject, transient } from "aurelia-dependency-injection";
import { RequestClientService } from "../basic/request-client.service";
import type { AddEntityAttachmentsRequest, AddEntityAttachmentsResponse, DocumentsCountResponse, GetEntityAttachmentsRequest, GetEntityAttachmentsResponse, RemoveEntityAttachmentsRequest, RemoveEntityAttachmentsResponse, AttachmentTypeModel, AttachmentRequestClientModel, AttachmentCommentClientModel } from "../../models/attachments.models";
import { ConfigService } from "../basic/config.service";
import { Urls } from "../../constants/attachment.constants";

@autoinject
@transient()
export class AttachmentsClientService {

    private _baseUrl: string;

    constructor(private requestClient: RequestClientService, private configService: ConfigService) {
        this._baseUrl = `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipAttachment`;
    }

    overrideBaseUrl(baseUrl: string) {
        //get the attachment base url from the config
        this._baseUrl = baseUrl;
        //fallback to qi url
        if(!this._baseUrl || this._baseUrl?.trim() == "") `${this.configService.config.urls.rightShipPlatformApiUrl}/api/v1/RightShipAttachment`
    }

    public saveAttachments(request: AddEntityAttachmentsRequest): Promise<AddEntityAttachmentsResponse> {
        return this.requestClient.postFormData(`${this._baseUrl}/${Urls.RightShipAttachment}`, request);
    }

    public getSharedAccessSignatureToken(entityAttachmentId: number, downloadFile: boolean): Promise<string> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetSharedAccessSignatureToken}`, { entityAttachmentId, downloadFile });
    }

    public getSharedAccessSignatureTokenFromPath(url: string, fileName:string): Promise<string> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetSharedAccessSignatureTokenFromPath}`, { url, fileName });
    }

    public deleteAttachments(request: RemoveEntityAttachmentsRequest): Promise<RemoveEntityAttachmentsResponse> {
        return this.requestClient.post(`${this._baseUrl}/${Urls.Delete}`, {}, request);
    }

    public getAttachments(request: GetEntityAttachmentsRequest): Promise<GetEntityAttachmentsResponse> {
        return this.requestClient.post(`${this._baseUrl}/${Urls.GetAttachments}`, {}, request);
    }

    public getDocumentCountsForEntity(entityId: number, entityTypeId: number): Promise<DocumentsCountResponse> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetDocumentsCountForEntity}/${entityId}/${entityTypeId}`, { });
    }

    public getAttachmentTypes(): Promise<AttachmentTypeModel[]> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetAttachmentTypes}`, { });
    }

    public getAttachmentRequests(entityId: number): Promise<AttachmentRequestClientModel[]> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetAttachmentRequests}/${entityId}`, { });
    }

    public getAttachmentComments(entityAttachmentId?: number, vetTaskMissingDocumentId?: number): Promise<AttachmentCommentClientModel[]> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetAttachmentComments}`, { entityAttachmentId: entityAttachmentId, vetTaskMissingDocumentId: vetTaskMissingDocumentId});
    }

    public saveAttachmentComment(comment: string, entityAttachmentId?: number, vetTaskMissingDocumentId?: number, attachmentCommentId?: number): Promise<number> {
        return this.requestClient.post(`${this._baseUrl}/${Urls.SaveAttachmentComment}`, {}, { attachmentCommentId: attachmentCommentId, entityAttachmentId: entityAttachmentId, vetTaskMissingDocumentId: vetTaskMissingDocumentId, comment: comment });
    }

    public deleteAttachmentComment(attachmentCommentId: number): Promise<void> {
        return this.requestClient.post(`${this._baseUrl}/${Urls.DeleteAttachmentComment}/${attachmentCommentId}`, {});
    }

    public deleteAttachmentRequest(id: number): Promise<void> {
        return this.requestClient.post(`${this._baseUrl}/${Urls.DeleteAttachmentRequest}/${id}`, {});
    }

    public getAttachmentTypesToExclude(entityId: number, entityTypeId?: number): Promise<number[]> {
        return this.requestClient.get(`${this._baseUrl}/${Urls.GetAttachmentTypesToExclude}/${entityTypeId}/${entityId}`, { });
    }
}
